import useMediaView from "features/common/hooks/useMediaView";
import UserDashboardWebPage from "./(web)/UserDashboardWebPage";
import React from "react";
import UserDashboardMobilePage from "./(mobile)/UserDashboardMobilePage";

const UserDashboardPage = () => {
  const isSmall = useMediaView("small");
  return (
    <>
      {!isSmall && <UserDashboardWebPage />}
      {isSmall && <UserDashboardMobilePage />}
    </>
  );
};

export default UserDashboardPage;
